import { createHandler } from 'griffin-paypal/number';

export default function parseAmount(value, metadata) {
  if (value === null || value === '') {
    return value;
  } else {
    const griffin = createHandler(metadata);
    const num = griffin.normalizeNumber(value);

    if (isNaN(num) || num <= 0) {
      return undefined;
    }

    // To match server-side validation
    if (Number.parseInt(num, 10).toString().length > 7) {
      return undefined;
    }

    return value;
  }
}
